var _path, _path2, _rect, _path3, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path4, _path5, _line, _circle, _circle2, _circle3, _g, _g2, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _mask, _rect3, _rect4, _rect5, _path40, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _rect6, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageSuspended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 317,
    viewBox: "0 0 295 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.367 161.077H213.785L212.843 233.278H207.192L204.367 161.077Z",
    fill: "#D4EBFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.86 161.077H281.278L280.336 233.278H274.686L271.86 161.077Z",
    fill: "#D4EBFA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 213.785,
    y: 161.077,
    width: 59.6448,
    height: 37.6704,
    fill: "#E3F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.089 161.075L199.883 153.227H283.296L285.986 161.075H198.089Z",
    fill: "#D3EBFB",
    stroke: "#D4EBFA",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 218.494,
    y: 168.923,
    width: 50.2272,
    height: 21.9744,
    rx: 1.35677,
    fill: "#D3EBFB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.822,
    cy: 179.911,
    rx: 3.924,
    ry: 1.5696,
    fill: "#EBF7FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.562,
    cy: 269.231,
    rx: 38.668,
    ry: 4.7487,
    fill: "#D2E7FE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.532,
    cy: 263.127,
    rx: 8.14064,
    ry: 5.42709,
    fill: "#CC5200"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.948,
    cy: 263.127,
    rx: 8.14064,
    ry: 5.42709,
    fill: "#CC5200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.818 116.32C161.67 109.258 172.097 109.258 176.948 116.32L264.195 243.321C269.761 251.424 263.96 262.446 254.13 262.446H79.6367C69.8067 262.446 64.0058 251.424 69.5719 243.321L156.818 116.32Z",
    fill: "#FF6600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.17 209.531C164.17 209.531 165.691 209.531 166.883 209.531C168.076 209.531 170.275 209.531 170.275 209.531",
    stroke: "#01006E",
    strokeWidth: 2.71354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 158.743,
    y1: 174.261,
    x2: 175.024,
    y2: 174.261,
    stroke: "#00006E",
    strokeWidth: 1.35677
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.884,
    cy: 183.075,
    r: 1.35677,
    fill: "#00006D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.029,
    cy: 195.288,
    r: 6.78386,
    fill: "#FABDEF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.737,
    cy: 195.288,
    r: 6.78386,
    fill: "#FABDEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1500_16272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.57 97.8836L164.689 97.4911C164.445 97.1739 164.275 96.817 164.181 96.4203C164.086 96.0235 164.083 95.6127 164.172 95.1877C164.252 94.8052 164.414 94.451 164.66 94.1252C164.931 93.7827 165.227 93.4786 165.549 93.2131L177.088 84.1455L178.746 84.4915C178.99 84.8086 179.159 85.1655 179.254 85.5623C179.374 85.9422 179.388 86.3553 179.295 86.8016C179.215 87.1841 179.042 87.536 178.775 87.8573C178.529 88.1831 178.233 88.4871 177.886 88.7695L166.57 97.8836ZM177.789 84.2919L177.024 87.9576L166.76 85.8152C166.698 85.5805 166.648 85.2927 166.608 84.9517C166.573 84.5896 166.59 84.2385 166.661 83.8985C166.799 83.2397 167.045 82.8032 167.4 82.5891C167.76 82.3537 168.184 82.287 168.673 82.389L177.789 84.2919ZM165.996 97.7638L166.761 94.0982L177.152 96.2672C177.244 96.4638 177.298 96.741 177.312 97.0987C177.351 97.4397 177.331 97.8014 177.251 98.1839C177.118 98.8214 176.872 99.2579 176.512 99.4933C176.174 99.7331 175.76 99.802 175.272 99.7L165.996 97.7638Z",
    fill: "#FF6600"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1500_16272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.887 25.6108L169.069 26.2309C168.697 26.0825 168.37 25.8616 168.086 25.5684C167.803 25.2752 167.591 24.9231 167.451 24.5122C167.325 24.1423 167.284 23.7547 167.329 23.3494C167.388 22.9165 167.488 22.5039 167.63 22.1116L172.941 8.43081L174.544 7.88425C174.916 8.03271 175.243 8.25356 175.527 8.54679C175.824 8.81247 176.046 9.16105 176.193 9.59252C176.319 9.96236 176.349 10.3534 176.283 10.7658C176.238 11.1711 176.138 11.5837 175.983 12.0036L170.887 25.6108ZM173.619 8.19957L174.828 11.7438L164.904 15.1282C164.731 14.9578 164.541 14.736 164.333 14.4628C164.118 14.1691 163.955 13.8579 163.843 13.5292C163.625 12.8922 163.615 12.3912 163.812 12.026C164.001 11.6402 164.332 11.3668 164.805 11.2056L173.619 8.19957ZM170.333 25.8L169.124 22.2558L179.171 18.8293C179.35 18.9516 179.537 19.1632 179.731 19.4639C179.939 19.737 180.106 20.0585 180.232 20.4284C180.443 21.0448 180.453 21.5458 180.263 21.9316C180.094 22.3103 179.774 22.5803 179.301 22.7414L170.333 25.8Z",
    fill: "#FF6600"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1500_16272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.98 58.2538L161.869 57.7981C161.756 57.5754 161.692 57.3368 161.679 57.0822C161.666 56.8276 161.711 56.5748 161.814 56.3237C161.907 56.0978 162.047 55.8987 162.235 55.7265C162.441 55.5468 162.658 55.3938 162.885 55.2673L171.01 51.0107L171.99 51.4123C172.103 51.635 172.167 51.8737 172.18 52.1283C172.21 52.3755 172.172 52.6309 172.064 52.8945C171.971 53.1204 171.824 53.3169 171.624 53.484C171.436 53.6562 171.219 53.8093 170.973 53.9432L162.98 58.2538ZM171.425 51.1806L170.537 53.346L164.473 50.8593C164.462 50.708 164.464 50.5254 164.478 50.3113C164.498 50.0847 164.549 49.871 164.631 49.6702C164.791 49.281 164.992 49.0409 165.235 48.9498C165.482 48.8461 165.751 48.8535 166.039 48.9719L171.425 51.1806ZM162.641 58.1148L163.53 55.9494L169.668 58.467C169.702 58.5983 169.703 58.7747 169.671 58.9961C169.656 59.2102 169.603 59.4302 169.51 59.6561C169.356 60.0327 169.155 60.2728 168.907 60.3765C168.672 60.4853 168.41 60.4805 168.121 60.3621L162.641 58.1148Z",
    fill: "#FF8533"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.828 290.253C105.828 290.253 106.691 291.367 106.977 292.169C107.445 293.483 106.977 295.681 106.977 295.681",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.542 288.896C108.542 288.896 109.405 290.01 109.69 290.811C110.159 292.126 109.69 294.323 109.69 294.323",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.255 288.222C111.255 288.222 112.118 288.657 112.403 289.459C112.872 290.773 112.403 292.97 112.403 292.97",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.969 287.543C113.969 287.543 114.831 288.657 115.117 289.458C115.586 290.773 115.117 292.97 115.117 292.97",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.683 286.19C116.683 286.19 117.545 287.303 117.831 288.105C118.3 289.42 117.831 291.617 117.831 291.617",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.396 285.511C119.396 285.511 120.258 285.946 120.544 286.748C121.013 288.063 120.544 290.26 120.544 290.26",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.109 284.154C122.109 284.154 122.972 284.589 123.258 285.391C123.727 286.705 123.258 289.581 123.258 289.581",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.823 283.475C124.823 283.475 125.686 284.589 125.972 285.391C126.44 286.705 125.972 288.902 125.972 288.902",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.536 282.118C127.536 282.118 128.399 283.231 128.685 284.033C129.153 285.348 128.685 287.545 128.685 287.545",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.25 282.118C130.25 282.118 131.113 283.231 131.398 284.033C131.867 285.348 131.398 287.545 131.398 287.545",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.964 280.76C132.964 280.76 133.827 281.874 134.112 282.676C134.581 283.99 134.112 286.188 134.112 286.188",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.472 194.602L78.0146 233.27C78.0146 233.27 91.6937 245.047 97.0095 254.979C103.41 266.937 104.472 288.898 104.472 288.898L132.964 279.401C132.964 279.401 134.093 264.449 132.964 254.979C131.396 241.825 129.219 234.348 123.467 222.416C117.849 210.764 104.472 194.602 104.472 194.602Z",
    fill: "#85D9C9",
    stroke: "#85D9C9",
    strokeWidth: 2.71354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0107 224.517C86.9879 228.495 90.2604 233.612 93.7207 238.055C99.5011 245.476 104.496 253.944 108.796 262.303C112.55 269.601 114.116 277.858 115.459 285.914",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6182 208.85C98.3428 215.999 103.924 222.66 108.543 229.88C111.84 235.035 114.831 240.586 117.739 245.99C123.798 257.253 125.579 269.636 127.537 282.116",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1006 244.251C92.5806 239.161 102.328 229.705 102.328 229.705C102.328 229.705 113.69 218.108 118.717 212.243",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6885 258.369C106.937 250.478 104.594 251.835 113.97 244.123C115.042 243.241 127.271 232.179 128.216 231.234",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.758 273.97C108.716 270.62 113.652 266.155 120.753 263.116C125.256 261.188 129.572 258.367 133.642 257.01",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.938 290.257C227.938 290.257 227.075 291.371 226.789 292.173C226.32 293.487 226.789 295.684 226.789 295.684",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.224 288.9C225.224 288.9 224.361 290.013 224.075 290.815C223.607 292.13 224.075 294.327 224.075 294.327",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M222.51 288.225C222.51 288.225 221.647 288.661 221.361 289.462C220.893 290.777 221.361 292.974 221.361 292.974",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.797 287.547C219.797 287.547 218.934 288.66 218.648 289.462C218.18 290.777 218.648 292.974 218.648 292.974",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.083 286.193C217.083 286.193 216.22 287.307 215.935 288.109C215.466 289.423 215.935 291.62 215.935 291.62",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M214.37 285.515C214.37 285.515 213.507 285.95 213.222 286.752C212.753 288.066 213.222 290.263 213.222 290.263",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M211.656 284.157C211.656 284.157 210.794 284.593 210.508 285.395C210.039 286.709 210.508 289.585 210.508 289.585",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M208.942 283.479C208.942 283.479 208.08 284.593 207.794 285.394C207.325 286.709 207.794 288.906 207.794 288.906",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M206.229 282.121C206.229 282.121 205.366 283.235 205.08 284.037C204.611 285.351 205.08 287.548 205.08 287.548",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M203.516 282.121C203.516 282.121 202.653 283.235 202.367 284.037C201.898 285.351 202.367 287.548 202.367 287.548",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M200.802 280.764C200.802 280.764 199.939 281.878 199.653 282.68C199.185 283.994 199.653 286.191 199.653 286.191",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M229.973 195.284L255.752 232.595C255.752 232.595 241.902 244.926 236.757 254.982C230.579 267.056 229.295 288.901 229.295 288.901L200.803 279.404C200.803 279.404 199.674 264.452 200.803 254.982C202.371 241.828 204.548 234.351 210.3 222.419C215.917 210.767 229.973 195.284 229.973 195.284Z",
    fill: "#85D9C9",
    stroke: "#85D9C9",
    strokeWidth: 2.71354,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M234.722 201.392C232.137 205.279 229.158 207.464 226.07 212.682C222.981 217.901 218.75 226.965 216.405 232.597C213.45 239.696 212.694 243.459 210.978 250.914C208.729 260.683 206.229 272.005 206.229 282.12",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M243.979 215.938C238.033 224.323 231.589 234.175 227.26 243.449C223.717 251.039 222.684 258.98 220.385 267.048C218.779 272.685 218.15 279.751 217.084 285.509",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M220.12 205.439C223.271 208.711 226.094 212.292 228.957 215.813C234.97 223.208 244.219 233.274 248.968 240.058",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M206.907 227.847C215.658 236.392 228.296 246.65 238.791 252.947",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M199.442 259.517C208.733 261.794 218.039 264.534 227.066 267.699C228.452 268.186 231.477 269.3 232.687 269.904",
    stroke: "#C0E9E1",
    strokeWidth: 1.35677,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-1_1500_16272",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.55957,
    y: 16.1938,
    width: 113.897,
    height: 126.355,
    rx: 2.71354
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.55957,
    y: 16.1938,
    width: 113.897,
    height: 126.355,
    rx: 2.71354,
    fill: "#EBF7FF",
    stroke: "#D4EBFB",
    strokeWidth: 8.14063,
    strokeLinejoin: "round",
    mask: "url(#path-53-inside-1_1500_16272)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56.9492,
    y: 16.1938,
    width: 5.33893,
    height: 126.355,
    fill: "#D4EBFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 146.104,
    width: 121.016,
    height: 7.11857,
    rx: 1.35677,
    fill: "#D4EBFA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0251 56.2379C14.5875 40.5075 30.2538 33.1025 30.2538 33.1025C30.2538 33.1025 28.3708 45.0406 32.562 51.472C35.8262 56.4808 44.4911 60.687 44.4911 60.687C44.4911 60.687 29.3636 65.1361 24.0251 56.2379Z",
    fill: "#D4EBFB",
    stroke: "#D4EBFB",
    strokeWidth: 1.35677,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6273,
    cy: 40.6873,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.3226,
    cy: 35.3448,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.356,
    cy: 28.223,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3734,
    cy: 65.5992,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6273,
    cy: 81.6222,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4066,
    cy: 115.435,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1527,
    cy: 126.108,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.4408,
    cy: 131.446,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5433,
    cy: 86.9605,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.1195,
    cy: 69.1622,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.797,
    cy: 97.637,
    r: 1.35677,
    fill: "#D4EBFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 187.234,
    y: 89.5601,
    width: 102.989,
    height: 6.05815,
    rx: 1.51454,
    fill: "#D4EBFA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M200.865 101.677L199.351 95.6184H207.681L206.166 101.677H200.865Z",
    fill: "#D4EBFB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M272.048 101.677L270.534 95.6184H278.106L276.592 101.677H272.048Z",
    fill: "#D4EBFB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M235.7 56.235C235.7 55.3985 236.378 54.7205 237.215 54.7205H241.758C242.595 54.7205 243.273 55.3985 243.273 56.235V89.5548H235.7V56.235Z",
    fill: "#D4EBFA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M243.272 50.181C243.272 49.3446 243.951 48.6665 244.787 48.6665H249.331C250.167 48.6665 250.845 49.3446 250.845 50.181V89.559H243.272V50.181Z",
    fill: "#D2E7FE",
    fillOpacity: 0.32
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M250.845 45.6371C250.845 44.8006 251.523 44.1226 252.359 44.1226H258.417C259.254 44.1226 259.932 44.8006 259.932 45.6371V89.5587H250.845V45.6371Z",
    fill: "#D4EBFA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M259.932 50.181C259.932 49.3446 260.61 48.6665 261.446 48.6665H267.504C268.341 48.6665 269.019 49.3446 269.019 50.181V89.559H259.932V50.181Z",
    fill: "#D2E7FE",
    fillOpacity: 0.32
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M267.505 57.7496C267.505 56.9132 268.183 56.2351 269.019 56.2351H275.078C275.914 56.2351 276.592 56.9132 276.592 57.7496V89.5549H267.505V57.7496Z",
    fill: "#D4EBFA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M220.232 63.5303H196.653L200.321 89.9908H217.088L220.232 63.5303Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M219.185 52.2661L215.037 63.2695H217.351L220.757 53.0521L219.185 52.2661Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M210.015 63.2708L213.42 52.0054L215.254 52.5293L212.635 63.2708H210.015Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M209.229 48.5999V63.2711H206.871L207.133 48.5999H209.229Z",
    fill: "#D3EBFB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M203.727 63.2711L202.199 51.4817H204.033L205.823 63.2711H203.727Z",
    fill: "#D3EBFB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M209.229 48.5999V63.2711H206.871L207.133 48.5999H209.229Z",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M203.727 63.2711L202.199 51.4817H204.033L205.823 63.2711H203.727Z",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M199.797 63.2683L196.915 53.3128L199.011 52.5269L202.417 63.2683H199.797Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M193.51 48.8649C194.239 51.0668 197.439 53.3186 197.439 53.3186L198.749 52.7946C198.749 52.7946 199.179 51.5371 199.273 50.6988C199.447 49.1603 199.489 48.1291 198.749 46.769C197.986 45.365 196.525 45.4562 195.606 44.1491C195.079 43.4007 194.558 42.0532 194.558 42.0532C194.558 42.0532 192.663 46.31 193.51 48.8649Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M218.761 47.9242C218.07 50.0749 215.04 52.2744 215.04 52.2744L213.8 51.7626C213.8 51.7626 213.393 50.5343 213.304 49.7155C213.139 48.2128 213.099 47.2056 213.8 45.8771C214.523 44.5058 215.906 44.5949 216.776 43.3181C217.275 42.5871 217.768 41.271 217.768 41.271C217.768 41.271 219.562 45.4288 218.761 47.9242Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M219.446 47.2942C218.718 49.0964 219.184 52.2719 219.184 52.2719L220.756 52.7959L221.28 52.2719C221.28 52.2719 224.354 49.6346 224.948 47.2942C225.479 45.2023 224.424 41.7925 224.424 41.7925C224.424 41.7925 223.661 42.9366 223.114 43.6264C221.856 45.2139 220.205 45.4162 219.446 47.2942Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M200.584 46.7642C200.812 48.79 202.156 51.742 202.156 51.742H203.728C203.728 51.742 205.317 48.4312 205.038 46.2402C204.701 43.5937 201.37 40.4766 201.37 40.4766C201.37 40.4766 200.308 44.3051 200.584 46.7642Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M205.562 43.3609C205.551 45.6257 207.395 48.8626 207.395 48.8626H208.967C208.967 48.8626 211.667 45.2339 211.587 42.575C211.509 39.9677 208.705 36.5493 208.705 36.5493C208.705 36.5493 205.575 40.4312 205.562 43.3609Z",
    fill: "#D3EBFB",
    stroke: "#D3EBFB",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M219.491 70.8668L219.753 69.2949L208.443 69.5569L197.439 69.2949L197.484 70.8668L208.443 71.1288L219.491 70.8668Z",
    fill: "#EBF7FF",
    stroke: "#EBF7FF",
    strokeWidth: 0.523971,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1500_16272",
    x: 158.305,
    y: 82.0229,
    width: 27.1745,
    height: 28.8639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.42709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71354
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1500_16272",
    x: 157.682,
    y: 7.45337,
    width: 28.5866,
    height: 29.947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.42709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71354
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16272",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1500_16272",
    x: 155.878,
    y: 48.5471,
    width: 22.3112,
    height: 23.0554,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.42709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71354
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1500_16272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1500_16272",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSuspended);
export default __webpack_public_path__ + "static/media/page-suspended.885a106c33dbc60a6fd34a5ae2627123.svg";
export { ForwardRef as ReactComponent };